import ProductItemCard from './product-item-card';

export default ProductItemCard;
